<template
  ><div class="test">{{ getDate }}</div></template
>
<script>
export default {
  props: ["date"],
  computed: {
    getDate() {
      if (this.date) {
        this.$i18n.locale;
        this.$moment.locale(this.$i18n.locale);
        return this.$moment(this.date.toDate()).format("L");
      } else {
        return "--";
      }
    }
  }
};
</script>
